import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useNavItems } from "./hooks";
import { isNavSectionOpen, isNavItemActive, getModalLinkState } from "./utils";
import { modalPaths } from "../../routers";
import { Dot } from "./styles";

/**
 * shared nav model to support both sidebar and menu
 */
const NavList = ({
  placement,
  showNested = false,
  onNavigate,
  onAddProject
}) => {
  const items = useNavItems(placement);
  const location = useLocation();

  return (
    <>
      {items.map(item => {
        if (item.key === "divider") {
          return <div key={item.key} className="nav-divider" />;
        }

        if (item.external) {
          return (
            <a
              key={item.key}
              className="nav-link"
              href={item.path}
              target="_blank"
              rel="noopener noreferrer"
              onClick={onNavigate}
            >
              <div className="nav-item">
                <span className="nav-item-title">{item.title}</span>
              </div>
            </a>
          );
        }

        const sectionOpen =
          showNested && isNavSectionOpen(item, location.pathname);

        return (
          <React.Fragment key={item.key}>
            <NavLink
              className={sectionOpen ? "nav-link open-nav-section" : "nav-link"}
              activeClassName="active-nav-item"
              to={
                modalPaths.includes(item.path)
                  ? { pathname: item.path, state: getModalLinkState(location) }
                  : item.path
              }
              onClick={onNavigate}
              isActive={() =>
                // menu hides nested links, so the parent highlights when it or any child is active
                showNested
                  ? isNavItemActive(item, location.pathname) &&
                    !item.nestedLinks
                  : // sidebar shows children, so parents with nested links never highlight themselves
                    isNavItemActive(item, location.pathname) ||
                    isNavSectionOpen(item, location.pathname)
              }
            >
              <div className="nav-item">
                <span className="nav-item-title">{item.title}</span>
              </div>
            </NavLink>

            {sectionOpen && (
              <div className="nav-section">
                {item.nestedLinks.map(link => (
                  <NavLink
                    key={link.key}
                    className="nav-link"
                    activeClassName="active-nav-item"
                    to={link.path}
                    onClick={onNavigate}
                  >
                    <div className="nav-item nav-item-nested">
                      {link.dotColor && (
                        <Dot color={link.dotColor} className="nav-dot" />
                      )}
                      <span className="nav-item-title">{link.title}</span>
                    </div>
                  </NavLink>
                ))}
                {item.key === "projects" && onAddProject && (
                  <div
                    className="nav-item nav-item-nested nav-add"
                    onClick={onAddProject}
                  >
                    + Add project
                  </div>
                )}
              </div>
            )}
          </React.Fragment>
        );
      })}
    </>
  );
};

export default NavList;
